export default async function (to, from, next) {
  if (to.query.token) {
    next();
  } else {
    next({ name: 'login' });
  }
}
